import React from "react";
import { BEM, T, useTranslate } from "@adapptio/lib-components";
import { capitalizeFirstLetter, isObject } from "@adapptio/lib-shared";
import { Icon, ICON_SIZE } from "@adapptio/lib-editor-ui";
import { Badge, BADGE_POSITION } from "../../../../../ui/components/Badge";
import { Markdown } from "../../../../../ui/components/Markdown";
import { TabsEditor } from "../TabsEditor/TabEditor";

export const ChildItem = ({ data, breadcrumbs, view, parentIdx, idx }) => {
	const baseClass = BEM("edt-reference-guide-main");
	breadcrumbs = [ ...breadcrumbs, data.label ];
	const type = capitalizeFirstLetter(data.type);
	const t = useTranslate();

	return (
		<>
			<div id={`${parentIdx}-${idx}`} className={baseClass.element("item").toClassName()}>
				<div className={baseClass.element("item-head").toClassName()}>
					<h4>
						{breadcrumbs.map((item, idx) => {
							if (idx < breadcrumbs.length - 1) {
								return (
									<div key={item + idx}>
										<span>
											<T domain="editor" term={item} />
										</span>
										<Icon
											className={baseClass.element("arrow").toClassName()}
											name="mdi/chevron-right"
											size={ICON_SIZE.MEDIUM}
										/>
									</div>
								);
							} else {
								return (
									<div key={data.label + idx}>
										{data.required && (
											<span>
												<T domain="editor" term={data.label} /> : {type}
											</span>
										)}
										{!data.required && (
											<Badge position={BADGE_POSITION.END} content="nullable">
												<T domain="editor" term={data.label} /> : {type}
											</Badge>
										)}
									</div>
								);
							}
						})}
					</h4>
					<hr />
				</div>
				<div className={baseClass.element("item-content").toClassName()}>
					<div>
						<Markdown>{t("editor", data.description)}</Markdown>

						{!!data.defaultValue &&
							(isObject(data.defaultValue) ? (
								<div className={baseClass.element("values-default").toClassName()}>
									<div>
										<p>Default value:</p>
									</div>
									<div>
										<ul>
											{Object.keys(JSON.parse(data.defaultValue)).map(
												(itemDefault, idx) => {
													if (itemDefault) {
														<li key={idx + "defaultVal"}>
															<b>
																{itemDefault}:{" "}
																{JSON.parse(data.defaultValue)[itemDefault]}
															</b>
														</li>;
													}
												}
											)}
										</ul>
									</div>
								</div>
							) : (
								<div className={baseClass.element("values-default").toClassName()}>
									<p>Default value:</p>
									<div>
										<Markdown>{t("editor", data.defaultValue)}</Markdown>
									</div>
								</div>
							))}

						{data.options && (
							<div className={baseClass.element("values").toClassName()}>
								<div>
									<p>Values:</p>
								</div>
								<div>
									<ul>
										{data.options.map((item, idx) => (
											<li key={idx}>
												<b>
													<T domain="editor" term={item.value} />
												</b>
											</li>
										))}
									</ul>
								</div>
							</div>
						)}
					</div>
					{data.descriptor && (
						<div>
							<TabsEditor descriptor={data.descriptor} examples={data.examples} />
						</div>
					)}
				</div>
			</div>
			{data.child?.length &&
				data.child.map((item, index) => {
					if (item) {
						return (
							<ChildItem
								key={item.label + index}
								data={item}
								breadcrumbs={breadcrumbs}
								view={view}
								parentIdx={idx}
								idx={index}
							/>
						);
					}
				})}
		</>
	);
};
